import * as React from 'react';
import { Col, Row } from 'react-bootstrap';

interface IAdmiralCardWarningProps {
  children: any,
  icon: string,
  title: string,
}

export const AdmiralCardWarning = ({
                                     children,
                                     icon,
                                     title,
                                   }: IAdmiralCardWarningProps) => {
  return (
    <div className={'adm-warning-card'}>
      <Row className={'adm-warning-card-section-header'}>
        <div className={'adm-icon-circle'}><img
          src={require(`../../../img/${icon}`)} alt={''}/></div>
        <Col xs={12} className={'adm-card-title'}>
          <h3>{title}</h3>
        </Col>
      </Row>
      <Row className={'adm-card-section-body'}>
        <Col xs={12}>
          {children}
        </Col>
      </Row>
    </div>
  )
}
